import { jsx as _jsx } from "react/jsx-runtime";
import { Head } from "@aviv-unified-frontend/runtime/head";
import { BRAND_CONFIGURATION } from "../../../../configs/brands";
const config = BRAND_CONFIGURATION.appBanner?.native?.ios;
/**
 * IOS Native Smart App Banner
 * https://developer.apple.com/documentation/webkit/promoting-apps-with-smart-app-banners#Implement-a-Smart-App-Banner-on-Your-Website
 */
export const IOSBanner = () => {
    if (!config)
        return null;
    const { id, clip } = config;
    return (_jsx(Head, { children: _jsx("meta", { name: "apple-itunes-app", content: `app-id=${id}, app-clip-bundle-id=${clip}` }) }));
};
